
export function getCustomPositionDescription(pos, bayId, rulesKey) {
  let positionDescriptions = []; 
  if (Array.isArray(pos)){
    pos.forEach(element => {
      positionDescriptions.push(getPosition(element, bayId, rulesKey));
    });
  }
  else{
    positionDescriptions.push(getPosition(pos, bayId, rulesKey));
  }

  return " (" + positionDescriptions.join(', ') + ")";
  }

  function getPosition(pos, bayId, rulesKey){
    let position;
    if(( rulesKey == "Grommet") && (bayId == 201 || bayId == 202) ){
      switch (pos) {
        case 'C':
        case '1':
          position = "Center Position";
          break;
        default:
          position = "";
          break;
      }
    }
    else{
      switch (pos) {
        case 'L':
        case '1':
          position = "Left Position";
          break;
        case 'C':
        case '2':
          position = "Center Position";
          break;
        case 'R':
        case '3':
          position = "Right Position";
          break;
        default:
          position = "";
          break;
      }
    }

    return position;
  }